import React from "react";
import withShipment from "../../../../withShipment";
import './ListingsTable.css';
import TopToolbar from "../../../global/subcomponents/topToolbar/TopToolbar";
import {EDIT_ENTRY, LISTING_TITLE, LISTINGS_PAGES, LISTINGS_ROWS_PER_PAGE_LABEL, SKU_FILTER_NAMES} from "../constants";
import TablePage from "../../../global/Table/TablePage";
import {Layout} from "../../../global/Table/TablePageHelpers/LayoutObject";
import ListingsTableRow from "../ListingsComponents/ListingsTableRow";
import {Filter} from "../../../global/Table/TablePageHelpers/FilterObject";
import RefreshIcon from "@material-ui/icons/Refresh";
import SettingsIcon from "@material-ui/icons/Settings";
import InfoIcon from '@material-ui/icons/Info';
import {
    availableLocationsSelector,
    listingsSelector,
    marketplacesSelector,
    responseMessageSelector,
    shippingTemplatesSelector
} from "../../../../redux/selectors/settings";
import {fetchAmazonSkus, fetchListings, listAvailableLocations, listShippingTemplates,} from "../../../../redux/actions/settings";
import {loadingSelector} from "../../../../redux/selectors/global";
import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CategoryIcon from '@material-ui/icons/Category';
import SetSkuLocationPopper from "./SetSkuLocationPopper";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import {userInfoSelector} from "../../../../redux/selectors/auth";
import {
    allShortcodesSelector,
    manufacturersSelector,
} from '../../../../redux/selectors/inventory';
import SetShippingTemplatePopper from "./SetShippingTemplatePopper";
import {SUCCESS} from "../../ManageUsers/constants";
import FeedbackBar from "../../../feedbackBar/FeedbackBar";
import {TimeIcon} from "@material-ui/pickers/_shared/icons/TimeIcon";
import {DocumentScanner} from "@mui/icons-material";
import SetHandlingTimePopper from "./SetHandlingTimePopper";
import { getAllProductInventory } from '../../../../redux/actions/inventory';
class ListingsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableEvents: [],
            shortcodeOptions: [],
            marketplaceOptions: this.props.marketplaces ? this.props.marketplaces.map(marketplace => marketplace.marketplaceName) : [],
            brandOptions: this.props.manufacturers ? this.props.manufacturers : [],
            listingIdBeingEdited: "",
            selectAllChecked: false,
            selectedEntries: [],
            isSelecting: false,
            feedbackBarOpen: false,
            feedbackSeverity: SUCCESS,
            feedbackBarText: "",
            selectedDeletedEntry: false
        }
    }

    componentDidMount(){
        this.props.listAvailableLocations()
        this.props.getAllProductInventory()
        this.props.listShippingTemplates({id: this.props.userInfo.company})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.marketplaces !== this.props.marketplaces && this.props.marketplaces) {

            let newMarketplaceOptions

            newMarketplaceOptions = this.props.marketplaces.map(marketplace => {
                return marketplace.marketplaceName
            })
            this.setState({
                marketplaceOptions: newMarketplaceOptions
            })
        }
        if (prevProps.manufacturers !== this.props.manufacturers && this.props.manufacturers) {

            const newbrandOptions = this.props.manufacturers
                .filter(brand => brand && brand !== "-")
                .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));

            this.setState({
                brandOptions: newbrandOptions
            })
        }

        if (this.props.isLoading) {
            this.props.setCurrentPage(LISTINGS_PAGES.LOADING)
        }

        if (prevProps.responseMessage !== this.props.responseMessage && this.props.responseMessage!=="") {
            this.openFeedBackBar(SUCCESS, this.props.responseMessage)
        }

        if (prevProps.allShortcodes !== this.props.allShortcodes && this.props.allShortcodes) {
          const shortcodes = Array.from(
            new Set(
              this.props.allShortcodes
                .map(item => item.shortcode)
                .filter(Boolean)
            )
          ).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

          this.setState({
            shortcodeOptions: shortcodes,
          });
        }
    }


    openFeedBackBar = (severity, message) =>{
        this.setState({
            feedbackBarOpen: true,
            feedbackSeverity: severity,
            feedbackBarText: message
        })
    }

    setOtherSkuFiltersFalse = (filterName, setTo) => {
        if (setTo === false) {
            return
        }

        let newTableEvents = []
        if (filterName !== SKU_FILTER_NAMES.ALL_SKUS) {newTableEvents.push(Filter.filterUpdateEvent(SKU_FILTER_NAMES.ALL_SKUS, false))}
        if (filterName !== SKU_FILTER_NAMES.ACTIVE_SKUS) {newTableEvents.push(Filter.filterUpdateEvent(SKU_FILTER_NAMES.ACTIVE_SKUS, false))}
        if (filterName !== SKU_FILTER_NAMES.INACTIVE_SKUS) {newTableEvents.push(Filter.filterUpdateEvent(SKU_FILTER_NAMES.INACTIVE_SKUS, false))}
        if (filterName !== SKU_FILTER_NAMES.UNMAPPED_SKUS) {newTableEvents.push(Filter.filterUpdateEvent(SKU_FILTER_NAMES.UNMAPPED_SKUS, false))}
        if (filterName !== SKU_FILTER_NAMES.DELISTED_SKUS) {newTableEvents.push(Filter.filterUpdateEvent(SKU_FILTER_NAMES.DELISTED_SKUS, false))}
        if (filterName !== SKU_FILTER_NAMES.DELETED_SKUS) {newTableEvents.push(Filter.filterUpdateEvent(SKU_FILTER_NAMES.DELETED_SKUS, false))}

        this.setState({
            tableEvents: newTableEvents
        })
    }

    isListingUnmapped = (row) => {
        return (
            (!row.shortcode) ||
            row.quantity === null ||
            row.shortcode === "" ||
            row.shortcode === null ||
            row.quantity === 0 ||
            row.quantity === "" ||
            row.quantity === "0" ||
            row.barcode === [] ||
            row.barcode === null ||
            row.barcode?.length === 0
        )
    }

    getTableColumnHeads = () => {
        let headers = []
        headers.push(Layout.columnHead(null, 'selectAllCheckbox', null))
        headers.push(Layout.columnHead("SKU", "sku", "Left"))
        headers.push(Layout.columnHead("ASIN", "asin", "Left"))
        headers.push(Layout.columnHead("Shortcode", "shortcode", "Left"))
        headers.push(Layout.columnHead("Quantity", "quantity", "Left"))

        const locationHeaderWithInfo = (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                Location
                <Tooltip title="Assigning a location indicates that the corresponding SKU belongs to that location. Inventory level for this location is used to manage inventory quantity on the marketplace when automatic inventory allocation is enabled.">
                    <InfoIcon style={{ marginLeft: 5, fontSize: 'small',color: 'gray' }} />
                </Tooltip>
            </div>
        );
        headers.push(Layout.columnHead(locationHeaderWithInfo, "shipAddressId", "Left"));
        headers.push(Layout.columnHead("Marketplace", "marketplaces", "Left"))
        headers.push(Layout.columnHead("Shipping Template", "shippingTemplate", "Left"))
        headers.push(Layout.columnHead("Handling Time", "handlingTime", "Left"))

        if (!this.state.listingIdBeingEdited) {
            headers.push(Layout.columnHead(null, "isDeleted", null));
        }else{
            headers.push(Layout.columnHead(null, null, null));
        }
        return headers;
    }

    handleSelectAllListing = (displayedTableRows) => {
        const { selectedEntries } = this.state

        const allSkus = displayedTableRows.map((row) => row.webstoreProductId)
        const missingSkus = allSkus.filter((webstoreProductId) => !selectedEntries.includes(webstoreProductId))

        let updatedSelectedEntries = []
        if (missingSkus.length > 0) {
            updatedSelectedEntries = [...selectedEntries, ...missingSkus]
        }

        const isSelecting = updatedSelectedEntries.length > 0

        const hasDeleted = displayedTableRows.some((row) => row.markAsDeleted === true)

        this.setState({
            selectedEntries: updatedSelectedEntries, isSelecting,
            selectedDeletedEntry: hasDeleted
        })
    }

    handleSelectListing = (row) => {
        this.setState(prevState => {
            const selectedEntries = new Set(prevState.selectedEntries);
            const selectedDeletedEntries = new Set(prevState.selectedDeletedEntries || []);
            if (selectedEntries.has(row.webstoreProductId)) {
                selectedEntries.delete(row.webstoreProductId);
                selectedDeletedEntries.delete(row.webstoreProductId);
            } else {
                selectedEntries.add(row.webstoreProductId);
                if (row.markAsDeleted) {
                    selectedDeletedEntries.add(row.webstoreProductId);
                }
            }

            return {
                selectedEntries: Array.from(selectedEntries),
                isSelecting: selectedEntries.size > 0,
                selectedDeletedEntry: selectedDeletedEntries.size > 0
            };
        });
    };

    getLocationName = (shipAddressId) => {
        const matchedLocation = this.props.availableLocations.find(loc => loc.shipAddressId === shipAddressId);
        return matchedLocation ? matchedLocation.name : "";
    }
    getTableRow = (row, getRowState, setRowState) => {
        return <ListingsTableRow
            row={row}
            availableShippingTemplates = {this.props.availableShippingTemplates}
            matchLocations={this.getLocationName}
            selectedEntries={this.state.selectedEntries}
            handleSelectListing={() => this.handleSelectListing(row)}   // pass the row
            getRowState={getRowState}
            setRowState={setRowState}
            listingIdBeingEdited={this.state.listingIdBeingEdited}
            setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
        />
    }

    handlePopperClose = () => {
        this.setState({
            selectedEntries: [],
            selectAllChecked: false,
        });
    };

    getSearchStrings = (row) => {
        let searchStrings = []
        if (row.sku)
            searchStrings.push(row.sku)
        if (row.quantity)
            searchStrings.push(row.quantity)
        if (row.shortcodeQuantity)
            searchStrings.push(row.shortcodeQuantity)
        if (row.asin)
            searchStrings.push(row.asin)
        if (row.brand)
            searchStrings.push(row.brand)

        return searchStrings
    }

    closeFeedbackBar = () => {
        this.setState({
            feedbackBarOpen: false
        })
    }

    render() {
        const selectInfo = `${this.state.selectedEntries.length} selected`
        const templateNames = [
            ...this.props.availableShippingTemplates?.map(template => template?.shippingTemplateName),
            "Unassigned" // Add null to the final result
        ];
        templateNames.sort((a, b) => {
            if (a === null) return 1;  // If a is null, place it at the end
            if (b === null) return -1; // If b is null, place it at the end
            return a.localeCompare(b); // Otherwise, compare alphabetically
        });
        const locationOptions = [
            ...this.props.availableLocations.map(location => location.name)
        ]

        let menuItems = [
            {title: selectInfo, isNotIcon: true},
            {title: "Set Location", icon: <CategoryIcon/>, onClick: () => {},
                popper: <SetSkuLocationPopper
                    locations={this.props.availableLocations}
                    skus={this.state.selectedEntries}
                    handlePopperClose={this.handlePopperClose}
                />
            }
        ]
        if(!this.state.selectedDeletedEntry){
            menuItems.push(
                {title: "Set Shipping Template", icon: <DocumentScanner/>, onClick: () => {},
                    popper: <SetShippingTemplatePopper
                        templates={this.props.availableShippingTemplates}
                        skus={this.state.selectedEntries}
                        handlePopperClose={this.handlePopperClose}
                        openFeedBackBar={this.openFeedBackBar}
                    />
                })
            menuItems.push(
                {title: "Set Handling Time", icon: <TimeIcon/>, onClick: () => {},
                    popper: <SetHandlingTimePopper
                        skus={this.state.selectedEntries}
                        handlePopperClose={this.handlePopperClose}
                        openFeedBackBar={this.openFeedBackBar}
                    />
                })

            if (this.state.selectedEntries.length === 1) {
                menuItems.splice(1, 0, {title: EDIT_ENTRY, icon: <EditIcon/>, onClick: () => {
                        this.setState({ listingIdBeingEdited: this.state.selectedEntries[0] });
                    }});
            }
        }

        return (
            <React.Fragment>
                {this.state.selectedEntries.length > 0 ?
                    <TopToolbar
                        pageName={LISTING_TITLE}
                        menuItems={menuItems}
                    />
                    :
                    <TopToolbar
                        pageName={LISTING_TITLE}
                        menuItems={[
                            {title: "Refresh Skus", icon: <RefreshIcon/>, onClick: () => {this.props.fetchAmazonSkus()}},
                            {title: "Settings", icon: <SettingsIcon/>, onClick: () => {this.props.setCurrentPage(LISTINGS_PAGES.SETTINGS)}},
                        ]}
                    />
                }
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    severity={this.state.feedbackSeverity}
                    message={this.state.feedbackBarText}
                    handleClose={this.closeFeedbackBar}
                />
                <TablePage
                    tableName="ListingsTable"

                    eventsVariable={this.state.tableEvents}
                    setEventsVariable={(newState) => {this.setState({tableEvents: newState})}}

                    tableColumnHeads={this.getTableColumnHeads()}
                    tableRows={this.props.tableRows}
                    rowFetcher={(filters) => {
                        this.props.fetchListings()
                    }}
                    handleSelectAll={this.handleSelectAllListing}
                    numSelectedEntries={this.state.selectedEntries.length}

                    tableRow={(row, index, getRowState, setRowState) => this.getTableRow(row, getRowState, setRowState)}
                    getRowId={(row) => row.webstoreProductId}
                    onRowDoubleClick={(row) => !row.markAsDeleted && this.setState({listingIdBeingEdited: row.webstoreProductId})}

                    paginationText={LISTINGS_ROWS_PER_PAGE_LABEL}

                    hasSearchField
                    searchStrings={this.getSearchStrings}

                    filters={[
                        Filter.createFilter("marketplace", (row) => row.marketplaces, null, Filter.relations.containsMemberOf, true),
                        Filter.createFilter("brand", (row) => row.brand, null, Filter.relations.containedBy, true),
                        Filter.createFilter("shortcode", (row) => row.shortcode, null, Filter.relations.containedBy, true),
                        Filter.createFilter("shippingTemplate", (row) => row.shippingTemplate, null, Filter.relations.containedBy, true),
                        Filter.createFilter("locationListingsPage", (row) => row.shipAddressId, null, Filter.relations.containedBy, true),

                        Filter.createFilter(SKU_FILTER_NAMES.ALL_SKUS, (row) => true, true, Filter.relations.equals, false),
                        Filter.createFilter(SKU_FILTER_NAMES.ACTIVE_SKUS, (row) => !row.isInactive && !row.markAsDeleted, false, Filter.relations.equals, false),
                        Filter.createFilter(SKU_FILTER_NAMES.INACTIVE_SKUS, (row) => row.isInactive && !row.markAsDeleted, false, Filter.relations.equals, false),
                        Filter.createFilter(SKU_FILTER_NAMES.UNMAPPED_SKUS, this.isListingUnmapped, false, Filter.relations.equals, false),
                        Filter.createFilter(SKU_FILTER_NAMES.DELISTED_SKUS, (row) => row.isDeleted && !row.markAsDeleted, false, Filter.relations.equals, false),
                        Filter.createFilter(SKU_FILTER_NAMES.DELETED_SKUS, (row) => row.markAsDeleted, false, Filter.relations.equals, false),
                    ]}

                    filterCheckboxes={[
                        Layout.checkBox(SKU_FILTER_NAMES.ALL_SKUS, "All Skus", <CircleOutlinedIcon/>, <CircleIcon/>, (setTo) => this.setOtherSkuFiltersFalse(SKU_FILTER_NAMES.ALL_SKUS, setTo)),
                        Layout.checkBox(SKU_FILTER_NAMES.ACTIVE_SKUS, "Active Skus", <CircleOutlinedIcon/>, <CircleIcon/>, (setTo) => this.setOtherSkuFiltersFalse(SKU_FILTER_NAMES.ACTIVE_SKUS, setTo)),
                        Layout.checkBox(SKU_FILTER_NAMES.INACTIVE_SKUS, "Inactive Skus", <CircleOutlinedIcon/>, <CircleIcon/>, (setTo) => this.setOtherSkuFiltersFalse(SKU_FILTER_NAMES.INACTIVE_SKUS, setTo)),
                        Layout.checkBox(SKU_FILTER_NAMES.UNMAPPED_SKUS, "Unmapped Skus", <CircleOutlinedIcon/>, <CircleIcon/>, (setTo) => this.setOtherSkuFiltersFalse(SKU_FILTER_NAMES.UNMAPPED_SKUS, setTo)),
                        Layout.checkBox(SKU_FILTER_NAMES.DELISTED_SKUS, "Delisted Skus", <CircleOutlinedIcon/>, <CircleIcon/>, (setTo) => this.setOtherSkuFiltersFalse(SKU_FILTER_NAMES.DELISTED_SKUS, setTo)),
                        Layout.checkBox(SKU_FILTER_NAMES.DELETED_SKUS, "Deleted Skus", <CircleOutlinedIcon/>, <CircleIcon/>, (setTo) => this.setOtherSkuFiltersFalse(SKU_FILTER_NAMES.DELETED_SKUS, setTo))
                    ]}

                    filterDropdown={Layout.newLayout(2, [
                        Layout.row([
                            Layout.rowElement(2, "marketplace", "Marketplace", Layout.elementStyle.checkboxDropdown, this.state.marketplaceOptions)
                        ]),
                        Layout.row([
                            Layout.rowElement(1, "brand", "Brand", Layout.elementStyle.checkboxDropdown, this.state.brandOptions),
                            Layout.rowElement(1, "shortcode", "Shortcode", Layout.elementStyle.checkboxDropdown, this.state.shortcodeOptions)

                        ]),
                        Layout.row([
                            Layout.rowElement(1, "locationListingsPage", "Location", Layout.elementStyle.checkboxDropdown, locationOptions),
                            Layout.rowElement(1, "shippingTemplate", "Shipping Template", Layout.elementStyle.checkboxDropdown, templateNames)

                        ]),
                    ])}
                />

            </React.Fragment>
        )
    }
}

ListingsTable.defaultProps = {
    tableRows: [],
    availableLocations: [],
    manufacturers: [],
}

ListingsTable.propTypes = {
    availableLocations: PropTypes.array,
    manufacturers: PropTypes.array,
}

const mapStateToProps = (state) => ({
    availableLocations: availableLocationsSelector(state),
    tableRows: listingsSelector(state),
    marketplaces: marketplacesSelector(state),
    isLoading: loadingSelector(state),
    availableShippingTemplates: shippingTemplatesSelector(state),
    userInfo: userInfoSelector(state),
    manufacturers: manufacturersSelector(state),
    responseMessage: responseMessageSelector(state),
    allShortcodes: allShortcodesSelector(state),
})

const actionCreators = {
    fetchListings,
    fetchAmazonSkus,
    listAvailableLocations,
    listShippingTemplates,
    getAllProductInventory
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, ListingsTable);